import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const PageHeader = memo(({ title, subtitle, breadcrumbs }) => (
  <div className="mb-12 animate-in fade-in slide-in-from-top-4 duration-500">
    <nav className="flex flex-wrap items-center text-sm text-slate-500 mb-6 gap-2">
      <Link to="/" className="hover:text-indigo-600 transition-colors">Home</Link>
      {breadcrumbs.map((crumb, idx) => (
        <React.Fragment key={idx}>
          <ChevronRight size={14} className="text-slate-300" />
          {crumb.link ? (
            <Link to={crumb.link} className="hover:text-indigo-600 transition-colors whitespace-nowrap">{crumb.label}</Link>
          ) : (
            <span className="text-indigo-600 font-bold whitespace-nowrap">{crumb.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
    <h1 className="text-4xl md:text-6xl font-black text-slate-900 tracking-tight mb-3">{title}</h1>
    {subtitle && <p className="text-lg text-slate-500 max-w-2xl leading-relaxed">{subtitle}</p>}
  </div>
));

export default PageHeader;